import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-my-health-plan',
  templateUrl: './my-health-plan.component.html',
  styleUrls: ['./my-health-plan.component.css']
})
export class MyHealthPlanComponent {
  @Input() data: any;
  @Output() closeModal = new EventEmitter();

  onCloseModal() {
    this.closeModal.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/features/my-needs/my-health-plan/my-health-plan.component.ts